import React from "react";

export default function SectionWrapper({ className, id, children }) {
  return (
    <div className={`min-h-[700px] ${className}`} id={id}>
      {children}
    </div>
  );
}
